module.exports = __webpack_public_path__ + "static/benjamin_-3ee60c6593589cc1338f8151fb052133.png";